import { SectionLayoutV2 } from '@/shared/ui/layout/SectionLayout';

import type { AnalysisSectionLayoutProps } from './AnalysisSectionLayout.types';
import { CitationNumberingProvider } from './CitationNumbering';

/**
 * `SectionLayout` for an IQ analysis section: the `split` header and the
 * content-after-header cascade, so the layout reads the same on screen and in the
 * exported PDF.
 *
 * Carries no actions: they sit on the page header, once at the top, rather than
 * repeating under every section heading.
 *
 * It is also where citation numbering is scoped. Every section's prose renders inside one
 * of these, so the numbers run continuously from the top of the section rather than
 * restarting at each block — and a section is the right scope because a section is what a
 * reader sees at once, and what the PDF exports as a document.
 */
export const AnalysisSectionLayout = ({
  title,
  subtitle,
  children,
}: AnalysisSectionLayoutProps) => (
  <CitationNumberingProvider>
    <SectionLayoutV2 variant="split" title={title} subtitle={subtitle}>
      {children}
    </SectionLayoutV2>
  </CitationNumberingProvider>
);
